import React from 'react';
import PropTypes from 'prop-types';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import Box from '@material-ui/core/Box';
import { useHistory } from 'react-router-dom';
import { getImageFile } from 'utils/stringUtils';

function AssessmentSmallCardList({ data }) {
  const resources = _get(data, 'fields.resources', []);

  const history = useHistory();

  if (_isEmpty(resources)) return null;

  const handleCardClick = slug => {
    history.push(`/assessments/${slug}`);
  };

  return (
    <Box mt={2}>
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '1rem',
          justifyContent: 'center',
        }}
      >
        {resources.map(resource => {
          const type =
            _get(resource, 'sys.contentType.sys.id') || resource.type;
          if (type !== 'Assessments' && type !== 'assessments') return null;

          const fields = resource.fields || resource;
          const { time, title, slug } = fields;
          const url = getImageFile(fields);

          return (
            <Box
              key={_get(resource, 'sys.id')}
              onClick={() => handleCardClick(slug)}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: '0.5rem',
                cursor: 'pointer',
              }}
              width={{ xs: '156px', md: '200px' }}
            >
              <Box
                overflow="hidden"
                height={{ xs: '156px', md: '200px' }}
                width={{ xs: '156px', md: '200px' }}
                position="relative"
                borderRadius="1.5rem"
              >
                <img
                  alt={title}
                  src={url}
                  width="100%"
                  height="100%"
                  objectFit="contain"
                  loading="lazy"
                />
                <Box
                  position="absolute"
                  bottom="0"
                  right="0"
                  bgcolor="#01619b"
                  px="12px"
                  py="2px"
                  color="white"
                  fontSize="10px"
                  sx={{
                    borderTopLeftRadius: '0.5rem',
                  }}
                >{`${time} MINS`}</Box>
              </Box>
              <Box fontSize="0.875rem" fontWeight="bold" textAlign="left">
                {title}
              </Box>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
}

AssessmentSmallCardList.propTypes = {
  data: PropTypes.object,
};

export default AssessmentSmallCardList;
